(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var image = document.querySelector('[data-article-hero-image]');
  if (!image) return;

  var container = image.parentElement;
  var ticking = false;

  function updateParallax() {
    var rect = container.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var travel = viewportHeight + rect.height;
    var progress = (viewportHeight - rect.top) / travel; // 0 entering viewport, 1 leaving it
    var offset = (progress - 0.5) * rect.height * 0.06; // +/- ~3% of the hero's own height
    image.style.transform = 'scale(1.12) translateY(' + offset.toFixed(2) + 'px)';
    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  updateParallax();
})();
